import { useTranslation } from "react-i18next";
import { popularModels } from "@/mocks/products";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function AboutAndModels() {
  const { t } = useTranslation();
  const { site } = useSiteSettings();

  const features = [
    { icon: "ri-team-line", title: t("about.f1title"), text: t("about.f1text", { siteName: site.site_name }) },
    { icon: "ri-star-line", title: t("about.f2title"), text: t("about.f2text") },
    { icon: "ri-checkbox-circle-line", title: t("about.f3title"), text: t("about.f3text") },
    { icon: "ri-tools-line", title: t("about.f4title"), text: t("about.f4text") },
  ];

  return (
    <section className="w-full bg-white">
      {/* Feature cards */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="rounded-lg border border-neutral-200 bg-neutral-50 p-6 text-center"
            >
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-brand-dark text-brand-gold">
                <i className={`${f.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold uppercase text-brand-dark">
                {f.title}
              </h3>
              <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{f.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Popular models */}
      <div className="w-full bg-brand-dark py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="text-center">
            <span className="text-xs font-medium uppercase tracking-widest text-brand-gold">
              {t("about.stockLabel")}
            </span>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl font-semibold uppercase text-white">
              {t("about.modelsTitle")}
            </h2>
            <p className="mx-auto mt-3 max-w-2xl text-sm text-white/60 leading-relaxed">
              {t("about.modelsDesc")}
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {popularModels.map((m) => (
              <div
                key={`${m.make}-${m.model}`}
                className="rounded-lg bg-white/5 border border-white/10 p-5 hover:border-brand-gold transition-colors"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-brand-gold/15 text-brand-gold">
                  <i className="ri-car-line text-xl"></i>
                </span>
                <h4 className="mt-3 font-heading text-base font-semibold text-white">
                  {m.model}
                </h4>
                <p className="text-xs text-neutral-400">{m.make}</p>
                <p className="mt-2 text-xs text-white/50 leading-relaxed">{m.note}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}